import { render, staticRenderFns } from "./TestElements.vue?vue&type=template&id=4b49d207&scoped=true&"
import script from "./TestElements.vue?vue&type=script&lang=js&"
export * from "./TestElements.vue?vue&type=script&lang=js&"
import style0 from "./TestElements.vue?vue&type=style&index=0&id=4b49d207&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b49d207",
  null
  
)

export default component.exports